import { useEffect } from "react";
import { RightPanel, useLayoutState } from "@etframework/ui.components";
import { CalendarContainer } from "../../components/RightPanelComponents/CalendarContainer";
import { useTranslation } from "react-i18next";
import { useBoardProvider } from "../../contexts/board/boardContext";

export const DueDatesRightPanel = () => {
  const { t } = useTranslation(["RightPanel"]);
  const { setRightPanelVisible } = useLayoutState();
  const { currentBoardId } = useBoardProvider();
  const ids = {
    main: "dd_right-panel",
    calendar: "dd_right-panel_calendar",
  };

  const rightPanelButtons = [
    {
      title: t("Calendar"),
      iconCss: "fa-regular fa-calendar-day",
    },
  ];

  const handlePanelClose = () => {
    setRightPanelVisible(false);
  };

  const handlePanelOpen = () => {
    setRightPanelVisible(true);
  };

  // re-render everytime currentBoardId changes
  useEffect(() => {}, [currentBoardId]);

  return (
    <RightPanel
      id={ids.main}
      tabNames={[t("Calendar")]}
      tabComponents={[
        () => (
          <CalendarContainer
            id={ids.calendar}
            key="calendar"
            currentBoardId={currentBoardId}
          />
        ),
      ]}
      tabIcons={["fa-regular fa-calendar-day"]}
      rightPanelButtons={rightPanelButtons}
      onPanelCollapse={handlePanelClose}
      onPanelOpen={handlePanelOpen}
      toolTipContent={t("CloseRightPanel")}
    />
  );
};
